<template>
  <TabBar activeTabName="misc" />
  <div class="row justify-content-center px-0 mx-0">
    <ProductMainList />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import ProductMainList from '@/components/fleet/ProductMainList.vue'
import NavigationService from '@/services/NavigationService'
import TabBar from '@/components/fleet/TabBar.vue'

@Options({
  components: {
    ProductMainList,
    TabBar
  }
})
export default class ProductsList extends Vue {
  mounted () {
    NavigationService.setNavLevel2('Fleet', 'Products', '#/fleet', '')
  }
}
</script>
